import Toast from '@/components/Toast';
import { useEffect, useState } from 'react';

const useBackGround = (props) => {
    const [sectionsObj, setSectionsObj] = useState({});
    let { simulation } = props.store;
    let { navigate } = props;
    let { background = {}, setHeaderIcon, caseInfo, verifyLogin, getPath } = simulation;
    let { sections = [] } = background;

    const onStart = async () => {
        let res = await verifyLogin();
        if (res) {
            let path = getPath();
            navigate(`${path}/factor`, { replace: true });
        }
    };
    const onClickCard = () => {
        Toast.info('请点击现在开始');
    };
    useEffect(() => {
        setHeaderIcon({
            role: false,
            back: false,
            reStart: false
        });
    }, []);
    useEffect(() => {
        let obj = {};
        sections.forEach((item) => {
            obj[item.section_id] = item;
        });
        setSectionsObj(obj);
    }, [sections]);
    return {
        sectionsObj,
        setSectionsObj,
        onStart,
        onClickCard
    };
};

export default useBackGround;
